import { defineMessages } from "react-intl";

export const boardBasisMessages = defineMessages({
  AI: { id: "hotels.boardBasis.AI" },
  BB: { id: "hotels.boardBasis.BB" },
  FB: { id: "hotels.boardBasis.FB" },
  HB: { id: "hotels.boardBasis.HB" },
  RD: { id: "hotels.boardBasis.RD" },
  RO: { id: "hotels.boardBasis.RO" },
  SC: { id: "hotels.boardBasis.SC" },
});

export function isKnownBoardBasis(
  value: string,
): value is keyof typeof boardBasisMessages {
  return Object.keys(boardBasisMessages).includes(value);
}
